import { useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box, Typography, useTheme } from '@mui/material';

import BalanceSvg from '@/assets/assetfi/Balance';
import PortfolioSvg from '@/assets/assetfi/Portfolio';
import SymbolSvg from '@/assets/assetfi/Symbol';
import CopySvg from '@/assets/assetfi/Copy';
import DisconnectSvg from '@/assets/assetfi/Disconnect';

import { walletState } from '@/atom/wallet';

const WalletMenu = ({ open, anchorEl, handleClose }: any) => {
  // theme
  const theme = useTheme();

  // router
  const navigate = useNavigate();

  // state
  const setWallet = useSetRecoilState(walletState);

  return (
    <Menu
      sx={{
        marginTop: '7.36px',
        padding: 0,
        '& .MuiMenu-list': {
          padding: 0,
        },
        '& .MuiPaper-root': {
          borderRadius: '10px',
          padding: 0,
          margin: 0,
        },
      }}
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Box sx={{ width: '320px' }}>
        <MenuItem
          onClick={() => navigator.clipboard.writeText('OxF9sd7...08dsl')}
          sx={{
            padding: '16px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey1}`,
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <SymbolSvg width={16} height={16} />
            <Typography variant="h6" color={theme.greyscale.darkgrey2}>
              OxF9sd7...08dsl
            </Typography>
          </Box>
          <CopySvg width={14} height={14} />
        </MenuItem>
        <MenuItem
          sx={{
            padding: '16px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey1}`,
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <BalanceSvg width={18} height={18} />
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              Balance
            </Typography>
          </Box>
          <Box sx={{ alignSelf: 'flex-end', textAlign: 'right' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: '600',
                lineHeight: '34px',
                letterSpacing: '-0.02em',
              }}
              color={theme.background.blue}
            >
              1,000 SFL
            </Typography>
            <Typography variant="body2" color={theme.background.blue}>
              ~ 200 USD
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            navigate('/portfolio');
          }}
          sx={{
            padding: '16px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey1}`,
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <PortfolioSvg width={18} height={18} />
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              Portfolio
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setWallet(false);
          }}
          sx={{
            padding: '16px',
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <DisconnectSvg width={18} height={18} />
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              Disconnect
            </Typography>
          </Box>
        </MenuItem>
      </Box>
    </Menu>
  );
};

export default WalletMenu;
